import {GPTypeStructure} from "./gp-typestructure";

export class GPTypeCustomTempStructure extends GPTypeStructure {
    constructor(gst) {
        super(gst);

        this.typeName = "GPTypeCustomTempStructure"
        this.id = parseInt(gst["id"]);
        this.type = "custom";
        this.temp = true;
        this.imgData = gst["imgData"];
        this.format = gst['type'];
        this.imgWidth = gst['imgWidth'];
        this.imgHeight = gst['imgHeight'];
    }

    staticGetPathForImage () {
        return this.imgData;
    }

    staticGetPathForThumb () {
        return this.imgData;
    }
}